export const KlaviyoBisButton = {
  name: "klaviyo-bis-button",
  template: `#klaviyo-bis-button`,
  props: ["selectedVariantId", "quickshopIsOpen", "product", "isAvailable"],
};
